const COMMUNITY_RULES = 'COMMUNITY_RULES';
const ITEM_RULES = 'ITEM_RULES';
const WISH_RULES = 'WISH_RULES';

export default {
  COMMUNITY_RULES,
  ITEM_RULES,
  WISH_RULES,
};
